export default __webpack_public_path__ + "static/media/laptop.d3be295b.svg";